<template>
  <div style="display: inline-block;">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'DesktopContent'
}
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: all 0.2s ease;
}
.fade-leave-active {
  transition: all 0.1s cubic-bezier(0.3, 0.4, 0.5, 0.6);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(-5px);
  opacity: 0;
}
</style>
